export const TIMELINE_REQUEST = "TIMELINE_REQUEST";
export const TIMELINE_SUCCESS = "TIMELINE_SUCCESS";
export const TIMELINE_FAILURE = "TIMELINE_FAILURE";